import React from 'react';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';
import clsx from 'clsx';
import { useMediaQuery } from '@/hooks/use-media-query';
import { Button } from '@/components/button';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import { Step } from './navigation-stepper';
import { Separator } from '../separator';
import styles from './header-visit-navigation.module.css';

export function HeaderVisitNavigation() {
  const { steps, editMode } = useVisitNavigation();
  const isMobile = useMediaQuery('--screen-md');

  if (isMobile) {
    return (
      <div className={styles.wrapperMobile}>
        {steps.map((step) => (
          <div
            key={step.path + step.name}
            className={clsx(styles.stepMobile, {
              [styles.active]: step.isActive || step.isCompleted,
            })}
          />
        ))}
      </div>
    );
  }

  const isDisabled = (step: Step) => {
    return step.nonNavigable || !step.isCompleted || step.isActive || editMode !== null;
  };

  return (
    <div className={styles.wrapper}>
      {steps.map((step, index) => (
        <React.Fragment key={step.path + step.name}>
          <Button
            variant="none"
            className={clsx(styles.step, {
              [styles.active]: step.isActive,
              [styles.completed]: step.isCompleted,
              [styles.disabled]: isDisabled(step),
            })}
            as="a"
            to={step.path}
            disabled={isDisabled(step)}
          >
            <MaterialSymbolIcon name="check" className={styles.checkIcon} weight={600} />
            {step.name}
          </Button>
          {index < steps.length - 1 && <Separator className={styles.separator} />}
        </React.Fragment>
      ))}
    </div>
  );
}
